import api from './api';

export const perjudicadosService = {
  listar:    (idSiniestro)       => api.get(`/siniestros/${idSiniestro}/perjudicados`),
  crear:     (idSiniestro, data) => api.post(`/siniestros/${idSiniestro}/perjudicados`, data),
  actualizar:(idSiniestro, id, data) => api.put(`/siniestros/${idSiniestro}/perjudicados/${id}`, data),
  eliminar:  (idSiniestro, id)   => api.delete(`/siniestros/${idSiniestro}/perjudicados/${id}`),
};
